import React from "react";
import { Nav, Navbar } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import Css from './Mockup.module.css';

export default function FooterMockup() {
    const navigate = useNavigate();

    const d = new Date();
    const year = d.getFullYear();

    const handlePrivacypolicy = (event) => {
        window.open(process.env.REACT_APP_WORDPRESS_PRIVACYPOLICY_URL, '_self');
    }

    const handleCookiePolicy = (event) => {
        window.open(process.env.REACT_APP_WORDPRESS_COOKIE_URL, '_self');
    }

    const handleTermsofuse = (event) => {
        window.open(process.env.REACT_APP_WORDPRESS_TERMSOFUSE_URL, '_self');
    }
    return (
        <footer className={`${Css.FooterMock} ${Css.PaddingFooter}`}>
            <div className="container">
            <Navbar className={`justify-content-center py-0`}>
                <Nav>
                    <Nav.Link onClick={handleTermsofuse} className={`${Css.ColorWhite}`}>เงื่อนไขบริการ</Nav.Link>
                    <Nav.Link disabled className={`${Css.ColorWhite}`}>|</Nav.Link>
                    <Nav.Link onClick={handlePrivacypolicy} className={`${Css.ColorWhite}`}>นโยบายความเป็นส่วนตัว</Nav.Link>
                    <Nav.Link disabled className={`${Css.ColorWhite}`}>|</Nav.Link>
                    <Nav.Link onClick={handleCookiePolicy} className={`${Css.ColorWhite}`} >นโยบายคุกกี้</Nav.Link>
                    {/*<Nav.Link disabled className={Css.ColorWhite}>|</Nav.Link>
                        <Nav.Link disabled className={`${Css.ColorGrey}`}>สอบถาม</Nav.Link>*/}
                    </Nav>
                </Navbar>
                <label className={`${Css.ColorWhite} ${Css.maginfooter1} d-block text-center`}>© Copyright {year} ISO DCaaS - All Rights Reserved by Magic Software (Thailand) Corp., Ltd. Version : {process.env.REACT_APP_VERSION}</label>
            </div>
        </footer>
        )
    
}